// extracted by mini-css-extract-plugin
export var navigation = "n_fF";
export var wrapper = "n_fy";
export var innerWrapper = "n_fG";
export var link = "n_fH";
export var svg = "n_fJ";
export var linkText = "n_fK";